import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '韩国伦理剧', to: '/category/ethical-drama' },
  { label: '热门推荐', to: '/category/popular' },
  { label: '专题合集', to: '/special' },
  { label: '关于我们', to: '/about' },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setMobileOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
      isActive
        ? 'text-primary-600'
        : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1200px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap" onClick={() => setMobileOpen(false)}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600">
            <i className="ri-movie-2-line text-lg text-background-50" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold tracking-wide text-foreground-950">韩国伦理剧</span>
            <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.18em] text-accent-600">
              Drama Portal
            </span>
          </span>
        </Link>

        <nav className="ml-2 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden items-center md:flex">
          <div className="relative">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm" />
            </span>
            <input
              type="text"
              name="q"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索剧名 / 主演 / 类型"
              className="h-10 w-52 rounded-md border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none lg:w-64"
            />
          </div>
          <button
            type="submit"
            className="ml-2 flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="打开导航菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="px-4 py-4">
            <form onSubmit={handleSearch} className="mb-4 flex items-center gap-2">
              <div className="relative flex-1">
                <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-sm" />
                </span>
                <input
                  type="text"
                  name="q"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索剧名 / 主演 / 类型"
                  className="h-10 w-full rounded-md border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
                />
              </div>
              <button
                type="submit"
                className="flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-4 text-sm font-medium text-background-50"
              >
                搜索
              </button>
            </form>
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-2.5 text-sm font-medium ${
                      isActive ? 'bg-background-100 text-primary-600' : 'text-foreground-700'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}